<ion-grid class="dropdown" [ngClass]="{ 'table-dropdown': table, 'dropdown-disabled': disabled  }">
  <ion-row class="dropdown__row">
    <ion-col size="auto" class="dropdown__row-label">
      <label class="dropdown__row-label-text">
        <img class="filter-body__container-icon" [src]="icon" />
        {{ selected ? selected[labelKey] : label }}
      </label>
    </ion-col>

    <ion-col size="auto" class="dropdown__row-select">
      <ion-select
        class="dropdown__row-select-dropdown"
        interface="popover"
        toggleIcon="chevron-down-outline"
        [value]="selected"
        [compareWith]="compareWith"
        (ionChange)="onSelectChange($event)"
        [disabled]="disabled"
      >
        <ion-select-option
          *ngFor="let option of filteredOptions"
          [value]="option"
        >
          {{ option[labelKey] }}
        </ion-select-option>
      </ion-select>
    </ion-col>
  </ion-row>
</ion-grid>
